import _ from "lodash";
import { graphql } from "lib/apolloClient";
import { prepareLoadMoreFeed } from "Utils";
import { CACHE_AND_NETWORK } from "Constants/stringConstants";

import { getNotificationsV2Query } from "./NotificationCenterV2Queries";
import { getNotificationListV2FromCache } from "./NotificationCenterV2GraphqlHelpers";

export const getNotificationsEnhancer = () =>
  graphql(getNotificationsV2Query, {
    name: "getNotificationsV2",
    options: ({ variables }) => ({
      fetchPolicy: CACHE_AND_NETWORK,
      variables,
    }),
    props({ getNotificationsV2, ownProps: { variables } }) {
      const cachedData = getNotificationListV2FromCache(variables);
      const notificationData = _.get(cachedData, "notification", []);
      const notifications = _.map(
        _.get(notificationData, "edge", []),
        ({ node }) => node
      );

      const pageInfo = _.get(notificationData, "pageInfo", {});
      const { hasNextPage = false, endCursor } = pageInfo;
      const networkStatus = getNotificationsV2.networkStatus;

      return {
        getNotificationsV2,
        notifications,
        isData: !_.isEmpty(notificationData),
        isLoading: _.includes([1, 2, 4], networkStatus),
        isFetchingMoreNotifications: networkStatus === 3,
        hasNextPage,
        networkStatus,
        onPusherEventTriggered: () => getNotificationsV2.refetch(),
        loadMoreNotifications: prepareLoadMoreFeed({
          variables: {
            ...variables,
            after: endCursor,
          },
          queryData: getNotificationsV2,
          key: "notification",
          edgesKey: "edge",
        }),
      };
    },
  });
